import { Box, CircularProgress } from '@mui/material';

export const Progress = () => (
  <Box sx={{ width: '100%', textAlign: 'center' }}>
    <CircularProgress />
  </Box>
);
